<template>
    <div class="tabcontent">

        <v-container :fluid="true" v-resize="onResize" ref="statiizatratcontainer">
            <v-row align="center">
                <v-col cols="4" md="3" sm="4">
                  <v-select
                      v-model="IdOrg"
                      :items="orglist"
                      label="Организация"
                      @input="refreshHandler"
                  ></v-select>
                </v-col>
                <v-col cols="4" md="3" sm="4">
                  <v-radio-group
                      v-model="Type"
                      row
                      mandatory
                  >
                    <v-radio
                        label="Поступления"
                        value="0"
                        @click="refreshHandler"
                    ></v-radio>
                    <v-radio
                        label="Расходы"
                        value="1"
                        @click="refreshHandler"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="4" md="3" sm="4">
                    <v-btn color="default" @click="importStaii" :loading="loading3">Импорт</v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-skeleton-loader
                :loading="loading"
                type="table-tbody"
                class="mx-auto"
        >
        <v-card>
            <v-btn
                    v-show="delcheckbox.length > 0"
                    color="primary"
                    dark
                    :fixed="true"
                    bottom
                    right
                    fab
                    @click="delClick"
                    style="z-index: 99;"
            >
                <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
            <v-btn
                   color="primary"
                   dark
                   :fixed="true"
                   top
                   right
                   fab
                   @click="addStaii"
                   style="z-index: 99; margin-top: 115px;"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-simple-table>
                <template>
                    <thead>
                    <tr>
                        <th style="padding-right: 0;">№</th>
                        <th style="padding-left: 0;">Наименование</th>
                        <th>Вид</th>
                        <th>Действие</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(group, indexgr) in staiilist">
                        <tr :key="'gr' + group.ID" v-show="group.Name != null">
                            <td style="padding-right: 0;">
                                {{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}
                            </td>
                            <td style="padding-left: 0;">
                                <div class="font-weight-bold">{{ group.Name }}</div>
                            </td>
                            <td>{{ typeszayav[group.Type] }}</td>
                            <td class="text-right" style="min-width: 120px; vertical-align: center;">
                                <v-btn color="default darken-1" icon @click="editClick(group.ID, indexgr+1, 0, 0)" class="mt-4"><v-icon>mdi-pencil</v-icon></v-btn>
                                <v-checkbox v-model="delcheckbox" dense multiple class="float-right" :value="group.ID"></v-checkbox>
                            </td>
                        </tr>
                        <template v-for="(stati, indexs) in group.sub">
                            <tr :key="'st' + stati.ID">
                                <td style="padding-right: 0;">
                                    {{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ stati.Numb>0 ? stati.Numb : indexs + 1 }}
                                </td>
                                <td style="padding-left: 0;">
                                    <div class="pl-2 font-weight-medium">{{ stati.Name }}</div>
                                </td>
                                <td>{{ typeszayav[stati.Type] }}</td>
                                <td class="text-right" style="min-width: 120px; vertical-align: center;">
                                    <v-btn color="default darken-1" icon @click="editClick(stati.ID, indexgr+1,indexs+1,0)" class="mt-4"><v-icon>mdi-pencil</v-icon></v-btn>
                                    <v-checkbox v-model="delcheckbox" dense multiple class="float-right" :value="stati.ID"></v-checkbox>
                                </td>
                            </tr>
                            <tr v-for="(substati, indexsub) in stati.sub" :key="'subst' + substati.ID">
                                <td style="padding-right: 0;">
                                  {{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ stati.Numb>0 ? stati.Numb : indexs + 1 }}.{{ substati.Numb>0 ? substati.Numb : indexsub + 1 }}
                                </td>
                                <td style="padding-left: 0;">
                                    <div class="pl-4">{{ substati.Name }}</div>
                                </td>
                                <td>{{ typeszayav[substati.Type] }}</td>
                                <td class="text-right" style="min-width: 120px">
                                    <v-btn color="default darken-1" icon @click="editClick(substati.ID, indexgr+1,indexs+1,indexsub+1)" class="mt-4"><v-icon>mdi-pencil</v-icon></v-btn>
                                    <v-checkbox v-model="delcheckbox" dense multiple class="float-right" :value="substati.ID"></v-checkbox>
                                </td>
                            </tr>
                        </template>
                    </template>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
        </v-skeleton-loader>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Удалить статьи</v-card-title>
                <v-card-text>
                    Удалить статьи оборота?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="gray darken-1" text @click="dialog = false">
                        Отмена
                    </v-btn>

                    <v-btn color="red darken-1" text @click="delStatii">
                        Удалить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="importtDialog" max-width="320">
            <v-card>
                <v-card-title class="headline">Импорт статей объекту</v-card-title>
                <v-card-text>
                    <v-file-input
                            v-model="fileimport"
                            :dense="true"
                            accept=".xls,.xlsx"
                    ></v-file-input>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="gray darken-1" text @click="importtDialog = false">
                        Отмена
                    </v-btn>

                    <v-btn color="green darken-1" text @click="importFileStatiiClick">
                        Импортировать
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="importtResult" max-width="320">
            <v-card>
                <v-card-title class="headline">Импорт статей оборота</v-card-title>
                <v-card-text>
                    Испорт выполнен: {{ importtMessage }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="gray darken-1" text @click="importtResult = false">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js';

    export default {
        name: "StatiiZatrat",
        mounted() {
            this.$store.dispatch('GET_STATIILIST', {Type:this.Type, IdOrg: this.IdOrg}).then(() => {
                this.loading = false;
            });
            this.$store.dispatch('GET_ORG_LIST', {});
            bus.$on('refreshTabStatiiZatrat', this.refreshHandler);
        },
        data() {
            return {
                loading: true,
                dialog: false,
                loading3: false,
                importtDialog: false,
                fileimport: null,
                importtResult: false,
                importtMessage: '',
                typeszayav: ['Поступления', 'Расходы'],
                delcheckbox: [],
                heightTable: (window.innerHeight - 200),
                Type:0,
                IdOrg: localStorage.getItem('idtsg'),
            }
        },
        computed: {
            staiilist() {
                return this.$store.getters.STATIILIST ? this.$store.getters.STATIILIST.data : [];
            },
            orglist() {
              let ret = [];
              if (this.$store.getters.ORG) {
                if(localStorage.getItem('idtsg')>0){
                  this.$store.getters.ORG.orglist.forEach((item) => {
                    if(item.ID == localStorage.getItem('idtsg'))
                      ret.push({text: item.Name, value: item.ID});
                  });
                }else{
                  this.$store.getters.ORG.orglist.forEach((item) => {
                    ret.push({text: item.Name, value: item.ID});
                  });
                }

              }
              return ret;
            }
        },
        methods: {
            addStaii() {
                this.$parent.addTab('Добавить статью', 0, 'StatiiZatratAdd', {id: 0, idx: 0, Type: this.Type, IdOrg: this.IdOrg});
            },
            importStaii() {
                this.importtDialog = true;
            },
            importFileStatiiClick() {
                if (this.fileimport && this.IdOrg>0) {
                    this.loading3 = true;
                    this.importtDialog = false;
                    this.$store.dispatch('IMPORT_STATIILIST', {
                        file: this.fileimport,
                        Type: this.Type,
                        IdOrg: this.IdOrg
                    }).then((data) => {
                        //console.log(data);
                        if (data.status == 1) {
                            this.importtMessage = 'Успешно загружено';
                        } else {
                            this.importtMessage = data.message;
                        }
                        this.refreshHandler();
                        this.importtResult = true;
                        this.loading3 = false;
                    }).catch(() => {
                        this.importtMessage = 'Ошибка';
                        this.importtResult = true;
                        this.loading3 = false;
                    });
                }
            },
            delClick() {
                this.dialog = true;
            },
            editClick(id, indexgr,indexs,indexsub) {
                let idx = (indexgr)+(indexs > 0 ? ("."+(indexs)+(indexsub > 0 ? "."+(indexsub): '')) : '');
                this.$parent.addTab('Изменить статью - ' + idx, id, 'StatiiZatratAdd', {id: id, idx: idx, Type: this.Type, IdOrg: this.IdOrg});
            },
            delStatii() {
                this.dialog = false;
                this.$store.dispatch('DEL_STATIILIST', {ids: this.delcheckbox}).then(() => {
                    this.delcheckbox = [];
                    this.refreshHandler();
                });
            },
            refreshHandler() {
                this.loading =  true;
                this.$store.dispatch('GET_STATIILIST', {Type:this.Type, IdOrg: this.IdOrg}).then(() => {
                  this.loading = false;
                });

            },
            onResize() {
                //this.heightTable = (window.innerHeight - this.$refs.statiizatratcontainer.clientHeight - 125);
            }
        },
        filters: {
            toCurrency(value) {
                if (value === undefined) value = 0;
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            toDate(value) {
                if (!value) return '';
                const [year, month, day] = value.split('-');
                return `${day}.${month}.${year}`;
            }
        }
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 35px;
    }
</style>